import React from "react";
import styled from "styled-components";
import { startCase } from "lodash";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { CheckboxIcon } from "@sonder/ui/source/styled/fragments/CheckboxIcon";
import { CheckboxWithLabel } from "@sonder/ui/source/styled/fragments/CheckboxWithLabel";
import { FilterGroupItem } from "@sonder/ui/source/styled/fragments/GenericFilters";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { borders } from "@sonder/ui/source/styled/theme";
import { TagsToIcons } from "core/queries/GetTags";
import { mapSquadToTagName } from "core/queries/GetTeam";
import { SquadTag } from "typings/globalGQLTypes";

const StyledAvatar = styled(Avatar)`
  border: ${borders.standard};
  margin-left: 0.831rem;
`;
interface SquadFilterGroupItemProps {
  isChecked: boolean;
  onClick(): void;
  squad: SquadTag;
}

export const SquadFilterGroupItem = ({
  isChecked,
  onClick,
  squad,
}: SquadFilterGroupItemProps) => {
  const Icon = TagsToIcons(mapSquadToTagName(squad));

  return (
    <FilterGroupItem fullWidth noBorder type="button" onClick={onClick}>
      <CheckboxWithLabel title={squad}>
        <CheckboxIcon checked={isChecked} />
        {Icon && <StyledAvatar name={squad} svg={<Icon />} />}
        <Label>{startCase(squad)}</Label>
      </CheckboxWithLabel>
    </FilterGroupItem>
  );
};
